import { configureStore } from "@reduxjs/toolkit";
import PriceSlice from "../redux/Slice/PriceSlice";
import termAndPolicySlice from "../redux/Slice/termsAndPolicy/termsAndPolicySlice";
import blogSlice from "../redux/Slice/blog/BlogSlice";

import contactUsSlice from "../redux/Slice/contactUs/ContactUsSlice";
import faqSlice from "../redux/Slice/FaqSlice";
export const store = configureStore({
  reducer: {
    price: PriceSlice,
    terms: termAndPolicySlice,
    blog: blogSlice,
    contact: contactUsSlice,
    faqs: faqSlice,
  },
});
